import { defineMessages } from 'react-intl';

export const planPeriodTabsMessages = defineMessages({
  annual: {
    defaultMessage: 'Yearly',
    id: 'WngbmaEcMo',
    description: 'Annual billing period tab',
  },
  monthly: {
    defaultMessage: 'Monthly',
    id: '9LfAkfoYm3',
    description: 'Monthly billing period tab',
  },
  savePercent: {
    defaultMessage: 'Save {percent}%',
    id: '/1vDc7oo7t',
    description: 'Discount badge on the annual billing period tab',
  },
});
